<div class="options-override-row">
  @if (!(dataService.isLoading$ | async)) {
    @if (dataService.component_types$.getValue().length <= 0) {
      <h3>
      No Component Types for selected Component Type!</h3>
    }
    @if (dataService.component_types$.getValue().length > 0) {
      <mat-form-field class="no-label">
        <mat-select (selectionChange)="setComponentType($event.value)"
          title="Select component type for column"
          [(ngModel)]="componentTypeID"
          [compareWith]="compareWith"
          [disabled]="readonly"
          placeholder="Select component type for column">
          @for (option of dataService.component_types$.getValue(); track option) {
            <mat-option [value]="option.id">
              {{option.attributes | nameAndDescription}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
  @if (dataService.isLoading$ | async) {
    <ngx-skeleton-loader
      count="1"
      title="Select Event Type to show Component Types"
      [theme]="{'margin-bottom': '0'}"
      class="progress-skeleton"
      animation="pulse"
      appearance="line"
    ></ngx-skeleton-loader>
  }
</div>
